import React from 'react';

import {Table} from 'spectra-logic-ui/components';

import {Account, LifecycleV2} from '@/types';
import {System} from '@/system/types';

type Props = {
  account: Account;
  lifecycles: LifecycleV2[];
  system: System;
}

const PropertiesDetails = ({account, lifecycles, system}: Props) => {
  let lifecycle: any = '';
  if (account.defaultLifecycleId) {
    const lc = lifecycles.find((l) => l.id === account.defaultLifecycleId);
    if (lc) {
      lifecycle = lc.name;
    }
  } else if (system.defaultLifecycleId) {
    const lc = lifecycles.find((l) => l.id === system.defaultLifecycleId);
    if (lc) {
      lifecycle = <span><i>Global Default</i> ({lc.name})</span>;
    }
  }

  const accountProps = [
    {key: 'ID', value: account.id},
    {key: 'Description', value: account.description},
    {key: 'Email', value: account.email},
    {key: 'Type', value: account.local ? 'Local' : 'AWS'},
    {key: 'Canonical ID', value: account.canonicalId},
    {key: 'Connection Limit', value: account.connectionLimit !== undefined ? account.connectionLimit + '%' : ''},
    {key: 'Default Lifecycle', value: lifecycle},
  ];
  if (!account.local) {
    accountProps.push({key: 'Role ARN', value: account.roleArn});
    accountProps.push({key: 'External ID', value: account.externalId});
  }
  accountProps.push({key: 'Status', value: account.inactive ? 'Inactive' : 'Active'});

  return (
    <Table>
      <Table.Body>
        {accountProps.map((kv) => (
          <Table.Row key={kv.key}>
            <Table.Cell>{kv.key}</Table.Cell>
            <Table.Cell>{kv.value}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default PropertiesDetails;
